import { Modal } from 'components/layout/Modal'
import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'

interface ExtensionListFailModalProps {
  isOpenExtensionListFailModal: boolean
  setIsOpenExtensionListFailModal: Dispatch<SetStateAction<boolean>>
}

export const ExtensionListFailModal = ({
  isOpenExtensionListFailModal,
  setIsOpenExtensionListFailModal,
}: PropsWithChildren<ExtensionListFailModalProps>) => {
  return (
    <Modal isModal={isOpenExtensionListFailModal}>
      <div className="bg-white w-[335px] h-auto p-[20px] border-t rounded-t-[20px]">
        <div className="flex flex-col items-center justify-center h-full gap-[24px]">
          <p className="font-bold text-[18px]">🧑‍💻 상품 불러오기 실패</p>
          <div className="flex flex-col leading-[22px]">
            <p className="text-[14px]">
              네트워크 오류로 <br />
              선택하신 상품을 모두 불러오지 못했어요
              <br />
              다시 한 번 선택해주세요!
            </p>
          </div>
        </div>
      </div>
      <div className="w-[335px] text-[14px]  h-[60px]  flex justify-center items-center">
        <button
          className="text-white w-[100%] h-full bg-main rounded-b-[20px] border-b border-main font-bold"
          onClick={() => {
            setIsOpenExtensionListFailModal((prev) => !prev)
          }}
        >
          <span>확인</span>
        </button>
      </div>
    </Modal>
  )
}
